module.exports = __webpack_public_path__ + "img/906dd19.jpg";